export const RequiredStar = () => {
    return <span className="jlt-text-red-400">*</span>;
};
